import { EMPTY_STR } from "@/constants/string";
import { TPagination } from "@/types/api";
import { formatNumber } from "@/utils/number";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TContactListTopProps = {
  pagination?: TPagination;
};

export const ContactListTop: FC<TContactListTopProps> = ({ pagination }) => {
  const totalText = pagination ? formatNumber(pagination.total) : EMPTY_STR.TEXT;
  const displayedText = pagination ? formatNumber((pagination.page - 1) * pagination.perPage + pagination.count) : EMPTY_STR.TEXT;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" gap={3} alignItems="center">
        <Typography variant="body14">{`全 ${totalText} 件中 ${displayedText} 件を表示`}</Typography>
      </Stack>
    </Stack>
  );
};
